/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import Script from 'next/script';
import React from 'react';
import environmentConfig from '@/config/environment';
import styles from './PaypalPayLaterMessaging.module.scss';
import { useNearViewport } from '../hooks/useNearViewport';
import { useForteDecisionFlagWithTrueDefault } from '@/features/forte/api/getForteDecision';

type Props = {
  pageType: 'catalog_product-detail';
  price: number;
};

export function PaypalPayLaterMessaging({ pageType, price }: Props) {
  const [paypalScriptReady, setPaypalScriptReady] = React.useState(false);
  const isPdpRedesignEnabled = useForteDecisionFlagWithTrueDefault('pdpRedesignEnabled');
  const { ref: sentinelRef, isInView } = useNearViewport<HTMLDivElement>();

  return (
    <div ref={sentinelRef}>
      {isInView ? (
        <Script
          src={`https://www.paypal.com/sdk/js?client-id=${environmentConfig.PAYPAL_CLIENT_ID}&components=messages`}
          strategy="lazyOnload"
          onReady={() => setPaypalScriptReady(true)}
        />
      ) : null}
      {paypalScriptReady ? (
        <div
          data-pp-message
          data-pp-pageType={pageType}
          data-pp-style-layout="text"
          data-pp-style-logo-type="primary"
          data-pp-style-text-color="black"
          data-pp-style-text-size="12"
          data-pp-placement="product"
          data-pp-amount={price}
          id="paypal-message"
          className={isPdpRedesignEnabled ? styles.paypalMessageShort : styles.paypalMessageTall}
        ></div>
      ) : null}
    </div>
  );
}
